// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QcDn","col":"styles_col__3MSMi"};